/* eslint-disable import/order */

import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { useSelector } from 'hooks/useSelector';
import { Dropdown } from 'ui/base';
import { switchLocale } from 'modules/i18n/actions';
import { getLocale } from 'modules/i18n/selectors/data';
import { getLanguages } from 'selectors/languageSelectors';

import * as stylesHeader from 'ui/layout/header/Header.module.less';
import { overlayStyle, overlayRootStyle } from 'ui/menus/style';
import { Wrapper, OptionLanguageWrapper, languageDropdownLocaleWrapper } from './UI';
import { getLanguageDisplayName } from 'utils/languageUtils';

const LanguageOption = ({ locale, isSelected, currentLocale }) => (
  <OptionLanguageWrapper className={classnames(isSelected && 'language-selected')}>
    <div className={languageDropdownLocaleWrapper}>
      {getLanguageDisplayName(locale)}
    </div>
    <div className={classnames('sub-title-language', languageDropdownLocaleWrapper)}>
      {getLanguageDisplayName(locale, currentLocale)}
    </div>
  </OptionLanguageWrapper>
);

const LanguageDropdown = () => {
  const dispatch = useDispatch();
  const currentLocale = useSelector(getLocale);
  const appLocales = useSelector(getLanguages);

  /** @param {import('antd/lib/menu').ClickParam} param */
  const handleMenuOnClick = React.useCallback(
    ({ key: newLocale }) => {
      dispatch(switchLocale(newLocale));
    },
    [dispatch]
  );
  const dropdownMenu = React.useMemo(
    () => ({
      selectedKeys: [currentLocale],
      className: overlayStyle,
      rootClassName: overlayRootStyle,
      onClick: handleMenuOnClick,
      items: [...(appLocales ?? [])]
        .sort()
        .map((locale) => ({
          key: locale,
          label: <LanguageOption locale={locale} isSelected={locale === currentLocale} currentLocale={currentLocale} />
        }))
    }),
    [appLocales, currentLocale, handleMenuOnClick]
  );

  const popupRender = React.useCallback((menu) => (
    <Wrapper>
      <h2 className="dropdown-language-title">
        <FormattedMessage id="selectLanguage" defaultMessage="Select your language" />
      </h2>
      {menu}
    </Wrapper>), []);

  return (
    <Dropdown
      trigger={['click']}
      menu={dropdownMenu}
      popupRender={popupRender}
    >
      <a
        className={classnames([stylesHeader['header-usernav__link'], stylesHeader['header-usernav__wrapper']])}
        data-cy="configuration_language_dropdown"
      >
        <span className={classnames([stylesHeader['header-usernav__label'], stylesHeader['header-usernav__language']])}>
          {getLanguageDisplayName(currentLocale)}
        </span>
        <i className={classnames([stylesHeader['header-usernav__caret-down'], 'fb-icon--arrow-down'])} />
      </a>
    </Dropdown>
  );
};

export default LanguageDropdown;
